module.exports = __webpack_public_path__ + "static/media/horario.ebd5622a.svg";